module.exports = __webpack_public_path__ + "img/undo-icon.2cf17422.svg";